import autosize from 'autosize';
import ko from 'lib/knockout';
import $ from 'jquery';

export default autosize;

window.autosize = autosize;

/**
 * Initializes Autosize plugin.
 * @param {string} method Allowed values: update, destroy
 * @return {JQuery}
 */
$.fn.autosize = function(method) {
	return this.each(function() {
		const el = this;
		const $el = $(this);
		if (typeof method === 'string') {
			if ($el.data('autosize') && typeof autosize[method] === 'function') {
				console.log('calling autosize.' + method, 'on', el);
				autosize[method](el);
				$el.data('autosize', null);
			}
		}
		else {
			const o = {
				/**
				 * Defer plugin initialization until textarea gets focus
				 */
				deferInit: false,

				...method
			};

			const init = () => {
				autosize(el);
				$el.data('autosize', true)
			};

			if (o.deferInit) {
				$el.one('focus', init);
			}
			else {
				init();
			}
		}
	});
};

/**
 * Binding for Autosize plugin
 */
ko.bindingHandlers.autosize = {
	init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
		const $el = $(element);
		const options = ko.unwrap(valueAccessor());
		let t;
		// autosize does not properly update itself when using with knockout
		// so manually fix it
		const update = () => {
			if (t) {
				clearTimeout(t);
			}
			t = setTimeout(() => {
				$el.autosize('update');
			}, 100);
		};
		$el.autosize(options).on('change', update);

		ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
			$(element).autosize('destroy').off('change', update);
		});
	}
};




// WEBPACK FOOTER //
// ./lib/autosize/index.js